import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentRoutingModule } from './payment-routing.module';
import { PaymentComponent } from './payment.component';
import { SharedModule } from '@app/@shared';
import { MaterialModule } from '@app/material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { ApplePayComponent } from './apple-pay/apple-pay.component';
import { NumberTranslatePipeModule } from '@app/@shared/pipes/number-translate/number-translate.module';
import { PaymentSuccessComponent } from './payment-success/payment-success.component';
import { I18nModule } from '@app/i18n';
import { TranslateModule } from '@ngx-translate/core';
import { PaymentStatusComponent } from './payment-status/payment-status.component';

@NgModule({
  declarations: [
    PaymentComponent,
    ApplePayComponent,
    PaymentSuccessComponent,
    PaymentStatusComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    ReactiveFormsModule,
    TranslateModule,
    I18nModule,
    NumberTranslatePipeModule,
    PaymentRoutingModule,
  ],
})
export class PaymentModule {}
